/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    DrmType,
    TransportEncodingType,
    VideoProviderConfiguration,
} from 'client-code/video-provider-configurations';
import { VPConfigurationsServiceRepositoryImpl } from '../impls/VPConfigurationsServiceRepositoryImpl';
import { IVPConfigurationsServiceRepository } from '../interfaces/IVPConfigurationsServiceRepository';
import { TServicesParams } from '../types/TServicesParams';

export class VPConfigurationsService implements IVPConfigurationsServiceRepository {
    private oVPConfigurationsServiceRepository: VPConfigurationsServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oVPConfigurationsServiceRepository = new VPConfigurationsServiceRepositoryImpl(params);
    }

    fetchVPConfigurationsForVideoPlayer(
        linearProviderPartnerId: string,
        forceNetworkCall?: boolean,
    ): Promise<Array<VideoProviderConfiguration>> {
        return this.oVPConfigurationsServiceRepository.fetchVPConfigurationsForVideoPlayer(
            linearProviderPartnerId,
            forceNetworkCall,
        );
    }

    async fetchVPConfigurations(
        supportedDrmType: Array<DrmType>,
        supportedTransportEncodingType: Array<TransportEncodingType>,
    ): Promise<void> {
        return this.oVPConfigurationsServiceRepository.fetchVPConfigurations(
            supportedDrmType,
            supportedTransportEncodingType,
        );
    }
}
